import { render, staticRenderFns } from "./MultiEvent.vue?vue&type=template&id=c89dad2e&scoped=true&"
import script from "./MultiEvent.vue?vue&type=script&lang=js&"
export * from "./MultiEvent.vue?vue&type=script&lang=js&"
import style0 from "./MultiEvent.vue?vue&type=style&index=0&id=c89dad2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89dad2e",
  null
  
)

export default component.exports